<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <span class="login-title">
                <img
                  :src="empresa.logoUrl"
                  width="100%"
                  style="max-width: 250px"
                />
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          v-for="evento in eventos"
                          :key="evento.id"
                        >
                          <v-card outlined>
                            <v-alert
                              v-if="evento.exibePorcentagem"
                              style="
                                margin: 0px;
                                text-align: center;
                                border-radius: 0px;
                              "
                              color="red"
                              dark
                              dense
                            >
                              <b v-if="evento.exigePagamento"
                                >{{
                                  (
                                    (evento.quantidadeInscricoes * 100) /
                                    evento.vagas
                                  ).toFixed(0)
                                }}% VENDIDOS</b
                              >
                              <b v-else
                                >{{
                                  (
                                    (evento.quantidadeInscricoes * 100) /
                                    evento.vagas
                                  ).toFixed(0)
                                }}% VENDIDOS</b
                              >
                            </v-alert>
                            <v-img
                              class="mx-auto"
                              height="auto"
                              width="100%"
                              :src="evento.urlCapa"
                            ></v-img>
                            <v-card-title class="mx-auto no-break">{{
                              evento.nome
                            }}</v-card-title>
                            <v-card-text>
                              <div>
                                <v-icon>mdi-calendar</v-icon>
                                {{ formatDateHora(evento.inicio) }}
                              </div>
                              <div style="margin-top: 5px" v-if="evento.local">
                                <v-icon>mdi-map-marker</v-icon>
                                {{ evento.local }}
                                <span v-if="evento.localizacao"
                                  >(<a
                                    :href="evento.localizacao"
                                    target="_blank"
                                    >Ver no mapa</a
                                  >)</span
                                >
                              </div>
                              <div
                                style="margin-top: 5px"
                                v-if="
                                  evento.exigePagamento &&
                                  !evento.valorPix &&
                                  !evento.valorCartao
                                "
                              >
                                <v-icon>mdi-ticket-confirmation</v-icon>
                                Setores disponíveis:
                                <ul
                                  style="margin: 0px; padding-left: 5px"
                                  v-for="valor in evento.setores"
                                  :key="valor.nome"
                                >
                                  <p
                                    :style="'margin: 0px; color: ' + valor.cor"
                                  >
                                    <v-icon
                                      :color="valor.cor"
                                      size="12"
                                      style="padding-bottom: 2px"
                                      >mdi-circle</v-icon
                                    >
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </p>
                                </ul>
                              </div>
                              <div
                                style="margin-top: 5px"
                                v-if="
                                  !evento.exigePagamento &&
                                  !evento.valorPix &&
                                  !evento.valorCartao
                                "
                              >
                                <v-icon>mdi-ticket-confirmation</v-icon>

                                <ul
                                  style="margin: 0px"
                                  v-for="valor in evento.setores"
                                  :key="valor.nome"
                                >
                                  <li>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </li>
                                </ul>
                              </div>
                              <div
                                style="margin-top: 5px"
                                v-if="evento.valorPix || evento.valorCartao"
                              >
                                <ul style="margin: 0px; padding-left: 5px">
                                  <p style="margin: 0px" v-if="evento.valorPix">
                                    <b>Lote:</b> {{ evento.lote }}
                                  </p>
                                  <p style="margin: 0px" v-if="evento.valorPix">
                                    <b>Pix:</b> R$ {{ evento.valorPix }}
                                  </p>
                                  <p
                                    style="margin: 0px"
                                    v-if="evento.valorCartao"
                                  >
                                    <b>Cartão:</b> em até
                                    {{ evento.quantidadeParcelas }}x de
                                    {{ calculaParcelas(evento) }}
                                  </p>

                                </ul>
                              </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="#3b3f3e"
                                :disabled="evento.quantidadeInscricoes >= evento.vagas ? true : false"
                                @click="realizarInscricaoGrupo(evento)"
                                >Comprar agora</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- <v-row align="center" justify="center">
                        <v-col cols="12" sm="12" md="9" lg="9">
                          <div>
                            <p
                              class="font-bold black-color"
                              style="text-align: center; font-size: 1.5rem"
                            >
                              Descrição do evento
                            </p>
                            <p class="font-regular black-color">
                              Sua imagem não é só o que o outro vê, mas a forma
                              como você se enxerga. Como você faz as coisas.
                            </p>
                            <p class="font-regular black-color">
                              Todos estão sempre olhando uma parte de nós que
                              não estamos vendo - nossa expressão visível no
                              mundo.
                            </p>
                            <p class="font-regular black-color">
                              Sabe aquela sensação de ouvir a própria voz? É
                              estranho, não é? A mesma coisa acontece com a
                              nossa imagem. Precisamos estar atentos.
                            </p>
                            <p class="font-bold white-color">
                              A forma como você se enxerga muda tudo. Muda
                              porque a beleza atrai e eleva.
                            </p>
                            <p class="font-regular black-color">
                              Lembre-se dos destinos de viagem que você prefere,
                              das frutas que escolhe quando vai ao supermercado,
                              das sobremesas que come primeiro com os olhos e de
                              tantas outras coisas que você escolheu por serem
                              bonitas.
                            </p>
                            <p class="font-regular black-color">
                              Talvez você não goste dos atributos que tem hoje.
                              Ou da forma como vem demonstrando quem você é. Mas
                              todos temos algo belo e bom para mostrar. Ninguém
                              está desequipado no universo da beleza.
                              Desajustados, talvez.
                            </p>
                            <p class="font-regular black-color">
                              Mas nós podemos te ajudar.
                            </p>
                            <p class="font-regular black-color">
                              Sabemos que há muita força guardada aí precisando
                              apenas de um impulso pra te elevar a outro patamar
                              — essa é a sua oportunidade de evoluir e chegar
                              lá.
                            </p>
                            <p class="font-regular black-color">
                              Ao dominar os aspectos da beleza, você viverá de
                              forma autêntica e criativa para forjar sua
                              personalidade e alcançar a excelência em suas
                              relações e nos negócios.
                            </p>
                            <p
                              class="font-regular black-color"
                              style="
                                font-size: 1.5rem;
                                background-color: #eeff41;
                              "
                            >
                              Inscreva-se e aprenda a ser mais impactante e agir
                              com mais persuasão, através da sua beleza!
                            </p>
                          </div>
                        </v-col>
                      </v-row> -->
                    </v-container>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      style="
                        text-align: center;
                        padding: 0px 10px 0px 10px;
                        margin-bottom: 17px;
                      "
                    >
                      <v-card flat>
                        <img
                          style="margin-right: 5px"
                          src="../../assets/site-seguro-blindado.png"
                          width="300px"
                        />
                      </v-card>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      v-if="empresa.telefone"
                      style="padding: 0px 10px 0px 10px"
                    >
                      <v-btn
                        depressed
                        block
                        style="border-radius: 7px"
                        large
                        :href="
                          'https://wa.me/55' +
                          empresa.telefone +
                          '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' +
                          empresa.nome +
                          '?'
                        "
                        target="_blank"
                      >
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    v-else-if="eventos.length == 0"
                  >
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador
                        {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados do cartão de crédito:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field
                        light
                        v-model="pagamento.nomeTitular"
                        label="NOME IMPRESSO NO CARTÃO"
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('nomeCartao')"
                        data-vv-name="nomeCartao"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        light
                        v-model="pagamento.cartaoNumero"
                        v-mask="maskCartao"
                        label="NÚMERO DO CARTÃO"
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('numCartao')"
                        data-vv-name="numCartao"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="pagamento.cpfTitular"
                        v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpftitular')"
                        data-vv-name="cpftitular"
                        label="CPF DO TITULAR"
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-text-field
                        light
                        v-mask="'###'"
                        v-model="pagamento.cvv"
                        label="CVV"
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        type="password"
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('codCartao')"
                        data-vv-name="codCartao"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select
                        outlined
                        dense
                        v-model="pagamento.mesVencimento"
                        :items="mesesVencimento"
                        hide-details
                        item-text="titulo"
                        item-value="id"
                        color="#00695C"
                        label="MÊS VENCIMENTO"
                        v-validate="'required'"
                        :error-messages="errors.collect('expiraCartaoMes')"
                        data-vv-name="expiraCartaoMes"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select
                        outlined
                        dense
                        v-model="pagamento.anoVencimento"
                        :items="anosVencimento"
                        hide-details
                        item-text="titulo"
                        item-value="id"
                        color="#00695C"
                        label="ANO VENCIMENTO"
                        v-validate="'required'"
                        :error-messages="errors.collect('expiraCartaoAno')"
                        data-vv-name="expiraCartaoAno"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select
                        outlined
                        dense
                        v-model="pagamento.bandeira"
                        :items="bandeiras"
                        hide-details
                        item-text="text"
                        item-value="value"
                        color="#00695C"
                        label="BANDEIRA"
                        v-validate="'required'"
                        :error-messages="errors.collect('bandeira')"
                        data-vv-name="bandeira"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select
                        outlined
                        dense
                        v-model="pagamento.valorEscolhido"
                        :items="parcelas"
                        hide-details
                        color="#00695C"
                        label="PARCELAS"
                        v-validate="'required'"
                        :error-messages="errors.collect('parcelas')"
                        data-vv-name="parcelas"
                        @input="carregaQtdParcelas"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha as informações de endereço e e-mail
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-mask="'#####-###'"
                        v-model="pagamento.cep"
                        label="CEP"
                        single-line
                        outlined
                        type="tel"
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="pagamento.numero"
                        label="NÚMERO DO ENDEREÇO"
                        single-line
                        outlined
                        type="tel"
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field
                        light
                        v-model="pagamento.email"
                        label="E-MAIL"
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs10 sm10 lg12 style="margin-top: 20px">
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h4 style="color: orange">
                        {{ eventoSelecionado.nome }}
                      </h4>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h2 style="color: orange" v-if="!textoParcela">
                        Total:
                        {{
                          valorTotalCompra.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </h2>
                      <h2 style="color: orange" v-else>{{ textoParcela }}</h2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn
                        dark
                        depressed
                        block
                        color="#00695C"
                        style="border-radius: 7px"
                        large
                        @click="pagamentoCartao"
                        >Realizar Pagamento</v-btn
                      >
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn
                        dark
                        depressed
                        block
                        color="#E53935"
                        style="border-radius: 7px"
                        large
                        @click="cancelarPagamento"
                        >Cancelar</v-btn
                      >
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img
                        src="../../assets/site-seguro-blindado.png"
                        width="100%"
                        style="max-width: 280px"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Selecione o evento que você deseja consultar:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select
                        outlined
                        dense
                        v-model="eventoId"
                        :items="eventos"
                        item-text="nome"
                        item-value="id"
                        color="#00695C"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados abaixo para consultar a inscrição:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field
                        light
                        label="CPF"
                        color="#00695C"
                        outlined
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpf')"
                        data-vv-name="cpf"
                        type="tel"
                        v-model="cpf"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn
                        dark
                        depressed
                        block
                        color="#00695C"
                        style="border-radius: 7px"
                        large
                        @click="consultarInscricao(cpf)"
                        >Consultar Inscrição</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->

        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      style="text-align: center"
                      v-if="eventoSelecionado.urlMapa"
                    >
                      <!-- <h3 style="margin: 0px">Mapa do evento</h3> -->
                      <img
                        :src="eventoSelecionado.urlMapa"
                        alt="MapaEvento"
                        width="100%"
                        style="max-width: 500px; margin-top: 10px"
                      />
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1>
                      <v-select
                        outlined
                        dense
                        hide-details
                        v-model="qtdCompra"
                        :items="quantidade"
                        @input="verificaCapacidade()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container
                  fluid
                  grid-list-md
                  v-for="index in qtdCompra"
                  :key="index"
                >
                  <v-layout row wrap justify-left style="margin-bottom: 20px">
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px" v-if="qtdCompra != 1">
                        Dados do {{ index }}º participante:
                      </p>
                      <p style="margin-bottom: 0px" v-else>
                        Dados do participante:
                      </p>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg12
                      v-if="eventoSelecionado.tipoDocumento == 'AMBOS'"
                    >
                      <v-radio-group
                        v-model="inscricao[index - 1].tipoDocumento"
                        row
                        @change="limpaSetor(index - 1)"
                      >
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                      <v-alert
                        v-if="
                          eventoSelecionado.desconto &&
                          inscricao[index - 1].tipoDocumento == 'CNPJ'
                        "
                        dark
                        type="success"
                        >Desconto de R$
                        {{ eventoSelecionado.desconto }} aplicado!</v-alert
                      >
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg4
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CPF' ||
                        inscricao[index - 1].tipoDocumento == 'CPF'
                      "
                    >
                      <v-text-field
                        label="CPF"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        @change="
                          verificaDocumento(
                            inscricao[index - 1].cpf,
                            index - 1,
                            'CPF'
                          )
                        "
                        prepend-inner-icon="mdi-card-account-details-outline"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg4
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CNPJ' ||
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      "
                    >
                      <v-text-field
                        label="CNPJ"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        v-mask="'##.###.###/####-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        @change="
                          verificaDocumento(
                            inscricao[index - 1].cpf,
                            index - 1,
                            'CNPJ'
                          )
                        "
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg8
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CPF' ||
                        inscricao[index - 1].tipoDocumento == 'CPF'
                      "
                    >
                      <v-text-field
                        label="NOME COMPLETO"
                        v-model="inscricao[index - 1].nome"
                        light 
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        label="WHATSAPP COM DDD"
                        v-model="inscricao[index - 1].telefone"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        hide-details
                        v-mask="'(##) #####-####'"
                        dense
                        required
                        prepend-inner-icon="mdi-whatsapp"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-autocomplete
                        label="ESTADO"
                        v-model="inscricao[index - 1].estado"
                        outlined
                        dense
                        :items="estados"
                        no-data-text="Nenhum estado encontrado"
                        hide-details
                        item-text="nome"
                        item-value="sigla"
                        color="#00695C"
                        :filter="customFilter"
                        prepend-inner-icon="mdi-map"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-autocomplete
                        label="CIDADE"
                        v-model="inscricao[index - 1].cidade"
                        outlined
                        dense
                        :items="retornaMunicipios(inscricao[index - 1].estado)"
                        no-data-text="Nenhuma cidade encontrada"
                        hide-details
                        item-text="municipio-nome"
                        item-value="municipio-nome"
                        color="#00695C"
                        :disabled="
                          inscricao[index - 1].estado != '' ? false : true
                        "
                        :filter="customFilterCidade"
                        prepend-inner-icon="mdi-city"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field
                        label="IGREJA"
                        v-model="inscricao[index - 1].igreja"
                        light
                        color="#00695C"
                        outlined
                        hide-details
                        dense
                        required
                        prepend-inner-icon="mdi-church"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field
                        label="CARAVANA"
                        v-model="inscricao[index - 1].caravana"
                        light
                        color="#00695C"
                        outlined
                        hide-details
                        dense
                        required
                        prepend-inner-icon="mdi-caravan"
                      ></v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 lg4>
                      <v-autocomplete label="ESTADO" v-model="inscricao[index-1].estado" outlined dense :items="estados" hide-details item-text="nome" item-value="sigla" color="#00695C"></v-autocomplete>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-autocomplete label="CIDADE" v-model="inscricao[index-1].cidade" outlined dense :items="retornaMunicipios(inscricao[index-1].estado)" hide-details item-text="municipio-nome" item-value="municipio-nome" color="#00695C" :disabled="inscricao[index-1].estado != '' ? false : true"></v-autocomplete>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg4> -->
                    <!-- <v-select label="SETOR" v-model="inscricao[index-1].setor" outlined dense :items="eventoSelecionado.setores" hide-details :item-text="getItemText" item-value="nome" color="#00695C" @input="calculaValorTotal(inscricao[index-1].setor, index-1)"> -->
                    <!-- <template slot="selection" slot-scope="data">
                          <p style="margin: 0px" v-if="eventoSelecionado.desconto && inscricao[index-1].tipoDocumento == 'CNPJ'">{{ data.item.nome }} (<span style="text-decoration: line-through">R$ {{ data.item.valor }}</span> R$ {{ (parseFloat(data.item.valor.replace(',','.')) - parseFloat(eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',') }})</p>
                          <p style="margin: 0px" v-else>{{ data.item.nome }} (R$ {{ data.item.valor }})</p>
                        </template>
<template slot="item" slot-scope="data">
                          <p style="margin: 0px" v-if="eventoSelecionado.desconto && inscricao[index-1].tipoDocumento == 'CNPJ'">{{ data.item.nome }} (<span style="text-decoration: line-through">R$ {{ data.item.valor }}</span> R$ {{ (parseFloat(data.item.valor.replace(',','.')) - parseFloat(eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',') }})</p>
                          <p style="margin: 0px" v-else>{{ data.item.nome }} (R$ {{ data.item.valor }})</p>
                        </template> -->
                    <!-- </v-select> -->
                    <v-flex>
                      <v-btn
                        v-if="index - 1 != 0"
                        block
                        depressed
                        @click="preencherInformacoes(index - 1)"
                        >Preencher informações</v-btn
                      >
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-divider
                        v-if="index != qtdCompra"
                        style="margin-top: 40px"
                      ></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 10px">
                      <template v-slot:label>
                        <div>
                          Concordo com as
                          <a
                            target="_blank"
                            href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_56a24bcaa9fe4680ad1992a0b375ceaa.pdf"
                            @click.stop
                            >políticas de privacidade e tratamento de dados
                            pessoais</a
                          >
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container
                  style="padding: 0px 12px 0px 12px"
                  v-if="eventoSelecionado.urlImgObs"
                >
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img
                      :src="eventoSelecionado.urlImgObs"
                      width="100%"
                      style="max-width: 300px"
                    />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: green">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    lg12
                    v-if="
                      !eventoSelecionado.valorPix &&
                      !eventoSelecionado.valorCartao
                    "
                  >
                    <h3 style="color: green">
                      Total:
                      {{
                        valorTotalCompra.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </h3>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    lg12
                    v-if="
                      eventoSelecionado.valorPix &&
                      eventoSelecionado.valorCartao
                    "
                  >
                    <h3 style="color: green" v-if="eventoSelecionado.valorPix">
                      Pix:
                      {{ (parseFloat(this.eventoSelecionado.valorPix.replace(",",".")) * this.inscricao.length).toLocaleString("pt-BR", {style: "currency", currency: "BRL",}) }}
                    </h3>

                    <h3
                      style="color: green"
                      v-if="eventoSelecionado.valorCartao"
                    >
                      Cartão: {{ eventoSelecionado.quantidadeParcelas }}x de {{ calculaParcelas(eventoSelecionado, this.inscricao.length) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <h3 style="color: green">
                      Almoço incluso no valor do ingresso
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn
                        depressed
                        block
                        outlined
                        style="border-radius: 7px"
                        large
                        @click="prosseguirPagamento('CARTÃO')"
                      >
                        <img
                          style="margin-right: 5px"
                          src="../../assets/credit-card.png"
                          width="25px"
                        />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4>
                      <v-btn
                        depressed
                        block
                        outlined
                        style="border-radius: 7px"
                        large
                        @click="prosseguirPagamento('PIX')"
                      >
                        <img
                          style="margin-right: 5px"
                          src="../../assets/pix.png"
                          width="20px"
                        />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img
                        style="margin-right: 5px"
                        src="../../assets/site-seguro-blindado.png"
                        width="250px"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <br />
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px" />
          </a>
        </div>

        <v-dialog v-model="dialogoIngressoIndividual" persistent max-width="380px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #FFFFFF;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ inscricaoLocalizada.nome }}</h3>
              </div>
              
              <div v-if="!inscricaoLocalizada.autopreenchimento" style="display: flex; justify-content: center; margin: 20px 0;">
                <div style="border: 1px solid #E0E7FF; padding: 12px; background-color: #FFFFFF; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <enhanced-qr-code 
                      :value="inscricaoLocalizada.cod_incricao" 
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p style="margin: 8px 0 0 0; font-size: 13px; font-weight: 500; color: #4B5563; text-align: center;">{{ inscricaoLocalizada.cod_incricao }}</p>
                  </div>
                </div>
              </div>
              
              <div v-if="inscricaoLocalizada.autopreenchimento" style="display: flex; justify-content: center; margin: 20px 0;">
                <router-link :to="'/editinsc?cod=' + inscricaoLocalizada.cod_incricao" style="text-decoration: none; width: 200px;">
                  <div style="border: 1px solid #FED7AA; padding: 12px; background-color: #FFF7ED; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05); text-align: center; width: 100%; cursor: pointer; transition: all 0.2s ease; position: relative; overflow: hidden;" class="qrcode-area-clicavel">
                    <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(245, 158, 11, 0.1); opacity: 0; transition: opacity 0.3s ease;" class="hover-overlay"></div>
                    <v-icon style="color: #F59E0B; font-size: 64px; margin-bottom: 8px;">mdi-qrcode-scan</v-icon>
                    <p style="margin: 0; font-size: 15px; font-weight: 500; color: #92400E; text-align: center;">QR Code indisponível</p>
                    <p style="margin: 8px 0 0 0; font-size: 13px; color: #92400E; text-align: center;">Clique aqui e complete seu cadastro para gerar o QR Code</p>
                    <v-btn style="margin-top: 12px; border-radius: 8px; text-transform: none; height: 36px; font-weight: 500; letter-spacing: 0.3px;" x-small depressed color="#F59E0B" dark>
                      <v-icon small left>mdi-pencil</v-icon>
                      Completar cadastro
                    </v-btn>
                  </div>
                </router-link>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div>
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-calendar</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">{{ inscricaoLocalizada.eventoNome }}</div>
                </div>
                
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-map-marker</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ inscricaoLocalizada.eventoLocal }}
                    <span v-if="inscricaoLocalizada.eventoLocalizacao">
                      (<a :href="inscricaoLocalizada.eventoLocalizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                    </span>
                  </div>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
              </div>
              
              <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                Guarde este comprovante para sua referência.
              </p>
            </v-card-text>
            <v-card-actions v-if="inscricaoLocalizada.autopreenchimento" style="padding: 0; display: none; background-color: #FFFFFF;">
              <router-link :to="'/editinsc?cod=' + inscricaoLocalizada.cod_incricao" style="width: 100%">
                <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0">
                  <v-icon left>mdi-pencil</v-icon>
                  Clique aqui e complete seu cadastro para gerar o QR Code
                </v-btn>
              </router-link>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;" v-if="inscricaoLocalizada.eventoUsaCartaoConsumo">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#4B5563"
                :href="'https://aiconsumer.intelite.com.br?cod=' + inscricaoLocalizada.cod_incricao">
                <v-icon left>mdi-hanger</v-icon>
                Cartão de consumo
              </v-btn>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoIngressoIndividual = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog
          v-model="dialogoListaIngresso"
          persistent
          max-width="600px"
          scrollable
        >
          <v-card>
            <v-card-title>Inscrições</v-card-title>
            <v-card-text style="padding: 0px 10px 0px 10px">
              <v-container style="padding: 12px 0px 12px 0px">
                <v-row style="margin: 10px">
                  <v-col cols="12" style="padding: 0px">
                    <p style="margin: 0px; font-weight: bold">
                      {{ eventoSelecionado.nome }}
                    </p>
                    <p style="margin: 0px; font-weight: bold">
                      <v-icon>mdi-map-marker</v-icon
                      >{{ eventoSelecionado.local }}
                      <span v-if="eventoSelecionado.localizacao"
                        >(<a
                          :href="eventoSelecionado.localizacao"
                          target="_blank"
                          >Ver no mapa</a
                        >)</span
                      >
                    </p>
                  </v-col>
                </v-row>
                <br />
                <v-row
                  align="center"
                  justify="center"
                  v-for="ingresso in inscricao"
                  :key="ingresso.nome"
                  style="
                    border: 1px solid #ccc;
                    margin: 10px;
                    text-align: center;
                  "
                >
                  <v-col cols="12" lg="4" style="padding: 2px">
                    <v-card outlined style="padding: 10px" color="white">
                      <qrcode-vue
                        :value="ingresso.cod_incricao"
                        :size="70"
                        level="H"
                        bg-color="white"
                      ></qrcode-vue>
                      <p style="margin: 0px; font-weight: bold">
                        {{ ingresso.cod_incricao }}
                      </p>
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="8" style="padding: 0px">
                    <p class="texto" style="margin: 0px">{{ ingresso.nome }}</p>
                    <p class="texto" style="margin: 0px">{{ ingresso.cpf }}</p>
                    <p
                      class="texto"
                      :style="
                        'background-color: ' +
                        ingresso.corSetor +
                        '; color: white; padding: 3px; margin: 0px'
                      "
                    >
                      SETOR: {{ ingresso.setor }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#7b4f44"
                @click="dialogoListaIngresso = false"
                >fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Fique atento! Após um dia útil, será enviada uma mensagem
                      no WhatsApp do número informado com a confirmação de
                      pagamento e o seu ingresso digital.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px">
                    <v-btn
                      style="border-radius: 7px"
                      dark
                      depressed
                      @click="abreBoleto"
                      >Visualizar Boleto</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#7b4f44"
                @click="closeDialog"
                >fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Sua inscrição foi pré-aprovada. Para confirmar, o
                      pagamento deve ser feito em mãos.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#7b4f44"
                @click="closeDialog"
                >fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      CPF : {{ inscricao.cpf }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p
                      class="texto"
                      style="background-color: #d32f2f; color: white"
                    >
                      Confirme a sua solicitação de cancelamento
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#00695C"
                @click="realizarCancelamento"
                >confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 4px">
              <span class="texto" style="color: #00695c; font-weight: bold">{{ msgResultado }}</span>
            </v-card-title>

            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" style="padding: 10px">
                    <p class="texto" style="text-align: left; font-weight: bold;">
                      Copie este código para pagar <b style="color: orange">R$ {{(parseFloat(valorTotalCompra) + parseFloat(valorAcrescimo.acrescimoPix)).toFixed(2).replace(".", ",")}}</b>:
                    </p>
                    <ol style="text-align: left; padding-left: 16px; margin: 0;">
                      <li>Acesse seu app de pagamentos.</li>
                      <li>Escolha pagar via Pix.</li>
                      <li>Cole o seguinte código:</li>
                    </ol>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card flat class="d-flex justify-center pa-4" color="white">
                      <enhanced-qr-code
                        v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'"
                        :value="qrCode64"
                        :size="230"
                        :margin="1"
                        :borderWidth="8"
                        borderColor="#FFFFFF"
                        :borderRadius="6"
                      ></enhanced-qr-code>
                      <img
                        v-else-if="exibirQRCode"
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                    <v-text-field
                      v-model="chaveCopiaeCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      disable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#00695C"
                      dark
                      depressed
                      @click="doCopy('chavePix')"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Copiar código
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      text
                      color="#00695C"
                      dark
                      @click="exibirQRCode = !exibirQRCode"
                      style="border-radius: 10px; font-size: 14px; "
                    >
                      {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px">
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <p>
                  <b
                    >Enviamos um token para seu WhatsApp.<br />Por favor,
                    informe-o abaixo para ter acesso ao seu ingresso digital:</b
                  >
                </p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px">
                    <v-text-field
                      light
                      v-mask="'####'"
                      v-model="token"
                      label="TOKEN"
                      type="tel"
                      single-line
                      outlined
                      color="#00695C"
                      dense
                      hide-details
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn
                  style="border-radius: 7px"
                  dark
                  block
                  depressed
                  color="#00695C"
                  @click="confirmaToken"
                  >Confirmar</v-btn
                >
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false"
          >Fechar</v-btn
        >
      </template>
    </v-snackbar>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#00695C"
      :is-full-page="fullPage"
    ></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
/* import vueCard from 'vue-card-express'; */
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import CpfValidate from "../../componentes/validators/rules/cpf";
import CnpjValidate from "../../componentes/validators/rules/cnpj";
import QrcodeVue from "qrcode.vue";
import { baseApiUrl /* modelBoleto */ } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";
import EnhancedQrCode from '../../componentes/EnhancedQrCode.vue'
export default {
  components: {
    Snackbar,
    QrcodeVue,
    Loading,
    EnhancedQrCode,
  },
  name: "Auth",

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
  }),

  data: function () {
    return {
      valorParcela: 0,
      timeout: 4000,
      snackbar: false,
      textoSnackbar: "",
      pagamentoPix: false,
      localPagamento: "",
      eventoId: "",
      cpf: "",
      email: "",
      qtdCompra: 1,
      pagePrincipal: true,
      pagePagamento: false,
      pageConsulta: false,
      PageIncricao: false,
      maskCartao: "#### #### #### ####",
      user: {},
      cultoSelecionado: "",
      inscricao: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          telefone: "",
          igreja: "",
          caravana: "",
          eventoId: "",
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          estado: "",
          cidade: "",
        },
      ],
      inscricaoDefault: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          telefone: "",
          igreja: "",
          caravana: "",
          eventoId: "",
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          estado: "",
          cidade: "",
        },
      ],
      pagamento: {
        valor: 0,
        cartaoNumero: "",
        cvv: "",
        mesVencimento: "",
        anoVencimento: "",
        nomeTitular: "",
        cpfTitular: "",
        bandeira: "",
        cep: "",
        numero: "",
        email: "",
      },
      dialogCancelamento: false,
      dialogoIngressoIndividual: false,
      confirmacaoBoleto: false,
      confirmacaoEmMaos: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ["MASCULINO", "FEMININO"],
      tipo: ["MEMBRO", "VISITANTE"],
      tamanhos: ["PP", "P", "M", "G", "GG", "XG"],
      quantidade: [],
      mesesVencimento: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      anosVencimento: [],
      eventos: [],
      condicoes: [
        { value: true, text: "SIM" },
        { value: false, text: "NÃO" },
      ],
      necessidades: ["AUDITIVA", "CADEIRANTE", "VISUAL"],
      bandeiras: [
        { value: "DINERS", text: "DINERS" },
        { value: "ELO", text: "ELO" },
        { value: "HIPERCARD", text: "HIPERCARD" },
        { value: "MASTERCARD", text: "MASTERCARD" },
        { value: "VISA", text: "VISA" },
      ],
      parcelas: [],
      modelCartao: {
        id: "",
        valor: "",
        tipoTransacao: "A_VISTA",
        quantidadeParcelas: 1,
        comprador: {
          id: "",
          documentoNumero: "",
          documentoTipo: "1",
          email: "",
          nomeCompleto: "",
          primeiroNome: "",
          ultimoNome: "",
          enderecoLogradouro: "",
          enderecoNumero: "",
          enderecoComplemento: "",
          enderecoCep: "",
          enderecoBairro: "",
          enderecoCidade: "",
          enderecoEstado: "",
        },
        cartao: {
          numero: "",
          codigoSeguranca: "",
          nome: "",
          expiracaoAno: "",
          expiracaoMes: "",
          bandeira: "",
        },
      },
      cobrancaAsaas: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
      },
      cobrancaAsaasCartao: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
        remoteIp: "",
        creditCard: {
          holderName: "",
          number: "",
          expiryMonth: "",
          expiryYear: "",
          ccv: "",
        },
        creditCardHolderInfo: {
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          phone: "",
        },
      },
      clienteAsaas: {
        name: "",
        cpfCnpj: "",
        email: "",
        mobilePhone: "",
        postalCode: "",
        addressNumber: "",
        notificationDisabled: true,
      },
      tokenAsaas:
        "49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3",
      qrCode64: "",
      chaveCopiaeCola: "",
      empresa: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: "",
      msgResultado: "",
      idInscricao: [],
      codigoAcesso: "",
      informaMunicipio: true,
      idClienteAsaas: "",
      valorAcrescimo: {
        acrescimoBoleto: 0.0,
        acrescimoPix: 0.0,
      },
      qtdInscMasculinas: 0,
      qtdInscFemininas: 0,
      vagasMasculinas: 0,
      vagasFemininas: 0,
      textoParcela: "",
      paginaInscricaoGrupo: false,
      caravana: false,
      inscricaoLocalizada: {
        cod_incricao: "",
        nome: "",
        email: "",
        telefone: "",
        eventoNome: "",
        eventoLocal: "",
        eventoLocalizacao: "",
        eventoUsaCartaoConsumo: "",
      },
      linkBoleto: "",
      consultaCPF: false,
      dialogoToken: false,
      token: "",
      divulgador: [],
      indicacao: false,
      possuiCupom: false,
      cupomDesconto: "",
      cupomAplicado: false,
      loader: null,
      loadingCupom: false,
      dadosCupom: [],
      qtdParcelas: null,
      usaCupomDesconto: null,
      tipoIngresso: "",
      eventoSelecionado: [],
      usaCartaoConsumo: null,
      bloqueiaVoltar: false,
      estados: [],
      municipios: [],
      tiposDocumento: ["CPF", "CNPJ"],
      valorTotalCompra: 0,
      aceiteLgpd: false,
      dialogoListaIngresso: false,
      exibirQRCode: false,
      dictionary: {
        custom: {
          nomeCartao: {
            required: () => "Informe o nome",
          },
          numCartao: {
            required: () => "Informe o número do cartão de crédito",
          },
          cpftitular: {
            required: () => "Informe o número do cartão de crédito",
          },
          codCartao: {
            required: () => "Informe o código de segurança",
          },
          expiraCartaoMes: {
            required: () => "Informe o mês de validade do cartão",
          },
          expiraCartaoAno: {
            required: () => "Informe o ano de validade do cartão",
          },
          dateOfBirth: {
            required: () => "Informe a Data de Nascimento",
            date_format: () => "Informe uma data válida (dd/mm/aaaa)",
          },
        },
      },
    };
  },

  mounted: async function () {
    await this.carregaDados();
    this.pegaParametrosUrl();
    this.$validator.localize("pt", this.dictionary);
    this.buscaUfs();
    this.buscaMunicipios();
  },

  watch: {
    dialogoIngressoIndividual(val) {
      if (val == false) {
        setTimeout(() => {
          let keys = Object.keys(this.inscricaoLocalizada);

          for (let i = 0; i < keys.length; i++) {
            this.inscricaoLocalizada[keys[i]] = "";
          }
        }, 300);
      }
    },

    dialogoListaIngresso(val) {
      if (val == false) {
        this.inscricao = Object.assign({}, this.inscricaoDefault);
        this.pagePrincipal = true;
        this.paginaInscricaoGrupo = false;
        this.pagePagamento = false;
        this.idInscricao = [];
      }
    },
  },

  methods: {
    retornaMunicipios(uf) {
      return this.municipios.filter(
        (municipios) => municipios["UF-sigla"] === uf
      );
    },

    criarQuantidades(quantidade) {
      this.quantidade = [];

      for (let i = 0; i < 51; i++) {
        if (i >= quantidade) {
          this.quantidade.push(i);
        }
      }
    },

    criarAnosVencimento() {
      this.anosVencimento = [];
      let anoAtual = new Date().toISOString().substring(0, 4);
      let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14;

      while (anoAtual <= anoFinal) {
        this.anosVencimento.push((anoAtual++).toString());
      }
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar = true;
        this.textoSnackbar = "Chave copiada para a área de transferência!";
      } catch (error) {
        this.snackbar = true;
        this.textoSnackbar =
          "Problema ao copiar chave para a área de transferência";
      }
    },

    reloadPage() {
      window.location.reload();
    },

    async carregaDados() {
      this.eventos = [];
      this.isLoading = true;

      await axios.post(baseApiUrl + "eventos/eventosFuturos", {empresaId: "6854628a06e7a18ed8d855c6"})
      .then(async (response) => {
        this.eventos = response.data.eventos;
        this.empresa = response.data.empresa;
        this.isLoading = false;
      });
    },

    calculaParcelas(evento, qtdCompra) {
      let valorTotal;

      if (qtdCompra) {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".")) + parseFloat(evento["acrescimoCartao" + evento.quantidadeParcelas].replace(",", "."));
        valorTotal = valorTotal * qtdCompra;
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      }
      else {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".")) + parseFloat(evento["acrescimoCartao" + evento.quantidadeParcelas].replace(",", "."));
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      }
      
      return valorTotal;
    },

    criarParcelas() {
      this.parcelas = [];
      for (let i = 0; i < this.qtdParcelas; i++) {
        // console.log(this.valorTotalCompra);
        // console.log(this.valorAcrescimo["acrescimoCartao" + (i + 1)]);
        this.parcelas.push(
          i +
            1 +
            "X de R$ " +
            (
              (
                parseFloat(this.valorTotalCompra) +
                parseFloat(
                  this.valorAcrescimo["acrescimoCartao" + (i + 1)].replace(
                    ",",
                    "."
                  )
                )
              ).toFixed(2) /
              (i + 1)
            )
              .toFixed(2)
              .replace(".", ",") +
            " (Total R$ " +
            (
              parseFloat(this.valorTotalCompra) +
              parseFloat(
                this.valorAcrescimo["acrescimoCartao" + (i + 1)].replace(
                  ",",
                  "."
                )
              )
            )
              .toFixed(2)
              .replace(".", ",") +
            ")"
        );
      }
    },

    cancelarPagamento() {
      //this.removeCupom()
      this.pagePagamento = false;
      if (this.caravana) {
        this.paginaInscricaoGrupo = true;
      } else {
        this.PageIncricao = true;
      }
    },

    /* formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }, */

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 8);
    },

    async acessaConsulta() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
    },

    async solicitaCancelamento() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
      if (
        this.inscricao.nome == "" ||
        this.eventoId == "" ||
        this.inscricao.cpf == ""
      ) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = false;
        this.dialogCancelamento = true;
      }
    },

    async realizarCancelamento() {
      this.idInscricao = "";
      this.isLoading = true;
      try {
        let res = await axios.get(
          `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`
        );
        if (res.data[0].id) {
          this.idInscricao = res.data[0].id;
        } else {
          this.isLoading = false;
          this.dialogCancelamento = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      } catch (error) {
        this.isLoading = false;
        this.dialogCancelamento = false;
        vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
          "ATENÇÃO"
        );
      }
      if (this.idInscricao != "") {
        try {
          let res = await axios.delete(
            `${baseApiUrl}Inscricoes/${this.idInscricao}`
          );
          if (res.data != "") {
            this.isLoading = false;
            this.inscricao = Object.assign({}, this.inscricaoDefault);
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Cancelamento realizado com sucesso!",
              "INFORMAÇÃO"
            );
          } else {
            this.isLoading = false;
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
              "ATENÇÃO"
            );
          }
        } catch (error) {
          this.isLoading = false;
          this.dialogCancelamento = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      }
    },

    async aplicaCupom() {
      var vm = this;

      if (this.cupomDesconto) {
        await axios
          .get(
            baseApiUrl +
              'Cupons?filter={"where":{"nome":"' +
              this.cupomDesconto.toUpperCase().trim() +
              '"}}'
          )
          .then((response) => {
            if (response.data) {
              if (
                response.data[0].nome.toUpperCase() ==
                  this.cupomDesconto.toUpperCase().trim() &&
                response.data[0].quantidade > response.data[0].utilizados
              ) {
                this.dadosCupom = response.data[0];
                this.cupomAplicado = true;
                this.valorTotalCompra = parseFloat(
                  parseFloat(this.valorTotalCompra) -
                    parseFloat(this.dadosCupom.valor)
                )
                  .toFixed(2)
                  .replace(".", ",");
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Cupom inválido ou esgotado!",
              "ATENÇÃO"
            );
          });
      }
    },

    removeCupom() {
      this.valorTotalCompra = parseFloat(
        parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)
      )
        .toFixed(2)
        .replace(".", ",");
      this.cupomAplicado = false;
      this.dadosCupom = [];
      this.possuiCupom = false;
      this.cupomDesconto = "";
    },

    async atualizaCupomsUtilizados() {
      await axios.patch(baseApiUrl + "Cupons/" + this.dadosCupom.id, {
        utilizados: this.dadosCupom.utilizados + 1,
      });
    },

    carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(
            this.parcelas[i].split("X")[0]
          );
          this.textoParcela = this.parcelas[i];
          this.pagamento.valor = this.parcelas[i]
            .match(/\(Total R\$ ([\d,]+)\)/)[1]
            .replace(",", ".");
          break;
        }
      }
    },

    async prosseguirPagamento(formaPagamento) {
      let vm = this;
      let inscricoesValidas = [];
      await this.pegaVagasDisponiveis();

      if (!this.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais",
          "ATENÇÃO"
        );
        return;
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        this.inscricao[i].setor = this.eventoSelecionado.setores[0].nome;
        this.inscricao[i].corSetor = this.eventoSelecionado.setores[0].cor;
        this.inscricao[i].valorPago =
          formaPagamento == "CARTÃO"
            ? this.eventoSelecionado.valorCartao
            : this.eventoSelecionado.valorPix;

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (
          this.inscricao[i].tipoDocumento == "CPF" &&
          !this.validarCamposInscricaoCPF(this.inscricao[i])
        ) {
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Preencha todos os campos corretamente do " +
              (i + 1) +
              "º participante para confirmar a inscrição!",
            "ATENÇÃO"
          );
          break;
        } else if (
          this.inscricao[i].tipoDocumento == "CNPJ" &&
          !this.validarCamposInscricaoCNPJ(this.inscricao[i])
        ) {
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Preencha todos os campos corretamente do " +
              (i + 1) +
              "º participante para confirmar a inscrição!",
            "ATENÇÃO"
          );
          break;
        } else {
          if (this.vagasDisponiveis[this.inscricao[i].setor] > 0) {
            inscricoesValidas.push(this.inscricao[i]);
          } else {
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Quantidade máxima do setor selecionado para o " +
                (i + 1) +
                "º participante foi atingido. Selecione outro setor.",
              "ATENÇÃO"
            );
            break;
          }
        }
      }

      if (inscricoesValidas.length === this.inscricao.length) {
        if (formaPagamento == "CARTÃO") {
          if (this.eventoSelecionado.valorCartao) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorCartao");
          }
          this.criarAnosVencimento();
          this.criarParcelas();
          this.pagamento.email = this.inscricao[0].email;
          this.paginaInscricaoGrupo = false;
          this.pagePagamento = true;
        } else if (formaPagamento == "PIX") {
          if (this.eventoSelecionado.valorPix) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorPix");
          }
          this.callFunctionPixPayment()
        } else if (formaPagamento == "BOLETO") {
          this.pagamentoBoleto();
        }
      }
    },

    validarCamposInscricaoCPF(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CpfValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === "" 
        // inscricao.igreja.trim() === "" ||
        // inscricao.caravana.trim() === "" ||
        // inscricao.estado.trim() === "" ||
        // inscricao.cidade.trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    validarCamposInscricaoCNPJ(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CnpjValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === "" 
        // inscricao.igreja.trim() === "" ||
        // inscricao.caravana.trim() === "" ||
        // inscricao.estado.trim() === "" ||
        // inscricao.cidade.trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    callFunctionPixPayment() {
      if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
        this.pagarPixTaPago()
      }
      else if (this.empresa.gatewayPagamentoPix == "ASAAS") {
        this.pagarPixAsaas()
      }
      else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
        this.pagarPixSicoob()
      }
    },

    calculaValorInscricoes(chave) {
      let valor;

      if (this.eventoSelecionado[chave]) {
        if (this.inscricao.length < 5) {
          valor =
            parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
            this.inscricao.length;
        } else {
          valor =
            parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
            this.inscricao.length *
            0.9;
        }
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        if (
          this.inscricao[i].tipoDocumento == "CNPJ" &&
          this.eventoSelecionado.desconto
        ) {
          valor -= parseFloat(
            this.eventoSelecionado.desconto.replace(",", ".")
          );
        }
      }

      return valor;
    },

    async realizarInscricaoPagamento() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.paginaInscricaoGrupo = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.PageIncricao = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoBoleto() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoEmMaos() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      if (await this.validaVagas()) {
        if (
          this.inscricao.dataNascimento != "" &&
          this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16
        ) {
          this.isLoading = false;
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Só é permitido a inscrição de maiores de 16 anos!",
            "ATENÇÃO"
          );
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf)
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.inscricao.statusPagamento = "PENDENTE";
            this.inscricao.formOfPayment = "EM MAOS";
            this.inscricao.valorPago = "330,00";
            this.realizarInscricao(this.finalizaInscricao);
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoPix() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.empresa.gatewayPagamentoPix == "TAPAGO"
              ? this.pagarPixTaPago()
              : this.pagarPixAsaas();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.empresa.gatewayPagamentoPix == "TAPAGO"
              ? this.pagarPixTaPago()
              : this.pagarPixAsaas();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    realizarInscricaoAgora() {
      this.pagePrincipal = false;
      this.PageIncricao = true;
      this.validaVagas();
      this.verificaCapacidade();
    },

    async realizarInscricaoGrupo(evento) {
      this.tipoIngresso = evento.nome;
      this.caravana = true;
      this.pagePrincipal = false;
      this.paginaInscricaoGrupo = true;

      this.inscricao = [];
      for (let i = 0; i < evento.vendaMinima; i++) {
        this.inscricao.push({
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          estado: "",
          cidade: "",
          telefone: "",
          igreja: "",
          caravana: "",
          eventoId: "",
          lote: "",
          tipo: "VIRTUAL",
          possuiNecessidade: false,
          necessidadeEspecial: "",
          tipoDocumento:
            evento.tipoDocumento == "AMBOS"
              ? evento.documentoPadrao
              : evento.tipoDocumento,
          valorPago: "",
        });
      }

      this.eventoSelecionado = evento;
      this.eventoId = evento.id;
      this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto;
      this.valorAcrescimo.acrescimoPix = evento.acrescimoPix;

      let keys = Object.keys(evento);
      keys = keys.filter((k) => k.includes("acrescimoCartao"));

      for (let i = 0; i < evento.quantidadeParcelas; i++) {
        if (keys[i]) {
          this.valorAcrescimo[keys[i]] = evento[keys[i]];
        } else {
          this.valorAcrescimo["acrescimoCartao" + (i + 1)] = "0,00";
        }
      }

      this.qtdParcelas = evento.quantidadeParcelas;
      this.usaCupomDesconto = evento.usaCupomDesconto;
      this.criarQuantidades(evento.vendaMinima);
      this.qtdCompra = evento.vendaMinima;
      // await this.verificaCapacidade()

      for (let i = 0; i < this.inscricao.length; i++) {
        if (evento.tipoDocumento == "AMBOS") {
          this.inscricao[i].tipoDocumento = evento.documentoPadrao;
        } else {
          this.inscricao[i].tipoDocumento = evento.tipoDocumento;
        }
      }

      this.valorTotalCompra = 0;

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async verificaDocumento(cpf, index, tipo) {
      let vm = this;
      let jaExiste = false;

      if (
        (tipo == "CNPJ" && !CnpjValidate(cpf)) ||
        (tipo == "CPF" && !CpfValidate(cpf))
      ) {
        return;
      }

      if (this.verificaCpfInformado(cpf, index)) {
        jaExiste = true;
        this.inscricao[index].cpf = "";
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "CPF não pode ser o mesmo de um já informado!",
          "ATENÇÃO"
        );
      }

      if (!jaExiste) {
        await axios
          .post(baseApiUrl + "inscricoes/consultarInscricaoCPF", {
            cpf: cpf,
            eventoId: this.eventoSelecionado.id,
          })
          .then((response) => {
            if (response.data.length > 0) {
              if (Object.keys(response.data[0]).includes("statusPagamento")) {
                if (response.data[0].statusPagamento == "PAGO") {
                  // exibir diálogo com QR Code do ingresso
                  this.inscricao[index].cpf = "";
                  this.inscricaoLocalizada = Object.assign(
                    {},
                    response.data[0]
                  );
                  this.dialogoIngressoIndividual = true;
                } else if (response.data[0].statusPagamento == "PENDENTE") {
                  this.inscricao[index].cod_incricao =
                    response.data[0].cod_incricao;
                  this.inscricao[index].cpf = response.data[0].cpf;
                  this.inscricao[index].nome = response.data[0].nome;
                  this.inscricao[index].telefone = response.data[0].telefone;
                  this.inscricao[index].email = response.data[0].email;
                  this.inscricao[index].dataNascimento =
                    response.data[0].dataNascimento;
                  this.inscricao[index].estado = response.data[0].estado;
                  this.inscricao[index].cidade = response.data[0].cidade;
                  this.inscricao[index].valorPago = response.data[0].valorPago;
                  this.inscricao[index].tipoDocumento =
                    response.data[0].tipoDocumento;
                  this.inscricao[index].id = response.data[0].id;
                }
              } else {
                this.inscricao[index].nome = response.data[0].nome
                  ? response.data[0].nome
                  : "";
                this.inscricao[index].cpf = response.data[0].cpf
                  ? response.data[0].cpf
                  : "";
                this.inscricao[index].dataNascimento = response.data[0]
                  .dataNascimento
                  ? response.data[0].dataNascimento
                  : "";
                this.inscricao[index].telefone = response.data[0].telefone
                  ? response.data[0].telefone
                  : "";
                this.inscricao[index].email = response.data[0].email
                  ? response.data[0].email
                  : "";
              }
            }
          });
      }
    },

    verificaCpfInformado(cpf, indice) {
      let cpfLocalizado = false;

      for (let i = 0; i < this.inscricao.length; i++) {
        if (i != indice) {
          if (this.inscricao[i].cpf == cpf) {
            cpfLocalizado = true;
            break;
          }
        }
      }

      return cpfLocalizado;
    },

    async validaVagas() {
      var vm = this;

      try {
        await axios
          .get(
            baseApiUrl +
              'inscricoes/count?where={"and":[{"eventoId":"' +
              this.eventoId +
              '"},{"sexo":"MASCULINO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count;
            }
          });
        await axios
          .get(
            baseApiUrl +
              'inscricoes/count?where={"and":[{"eventoId":"' +
              this.eventoId +
              '"},{"sexo":"FEMININO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count;
            }
          });
        /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
        if (res.data.length > 0)
          res.data.forEach(insc => {
            if (insc.sexo == 'MASCULINO')
              this.qtdInscMasculinas = this.qtdInscMasculinas + 1
            else if (insc.sexo == 'FEMININO')
              this.qtdInscFemininas = this.qtdInscFemininas + 1
          }); */

        if (this.inscricao.sexo == "MASCULINO") {
          //this.qtdInscMasculinas = this.vagasMasculinas
          if (this.qtdInscMasculinas == this.vagasMasculinas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para homens foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else if (this.inscricao.sexo == "FEMININO") {
          if (this.qtdInscFemininas == this.vagasFemininas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para mulheres foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else {
          this.isLoading = false;
          return true;
        }
      } catch (error) {
        //
      }
    },

    preencherInformacoes(indice) {
      if (
        this.inscricao[0].cpf == "" ||
        this.inscricao[0].nome == "" ||
        this.inscricao[0].telefone == "" ||
        this.inscricao[0].igreja == "" ||
        this.inscricao[0].caravana == "" ||
        this.inscricao[0].estado == "" ||
        this.inscricao[0].cidade == ""
      ) {
        let vm = this;
        vm.$refs.chamaSnackbar.snack(
          "##F9A825",
          "Preencha os dados do primeiro participante antes de replicar as informações!",
          "ATENÇÃO"
        );
      } else {
        let answer = confirm(
          "Deseja preencher os dados desta inscrição com os dados da primeira inscrição?"
        );

        if (answer) {
          this.inscricao[indice].cpf = this.inscricao[0].cpf;
          this.inscricao[indice].nome = this.inscricao[0].nome + " " + (indice + 1);
          this.inscricao[indice].email = this.inscricao[0].email;
          this.inscricao[indice].telefone = this.inscricao[0].telefone;
          this.inscricao[indice].igreja = this.inscricao[0].igreja;
          this.inscricao[indice].caravana = this.inscricao[0].caravana;
          this.inscricao[indice].estado = this.inscricao[0].estado;
          this.inscricao[indice].cidade = this.inscricao[0].cidade;
        }
      }
    },

    async realizarInscricao(callback = null, formaPagamento, textoParcela) {
      this.isLoading = true;
      let vm = this;

      for (let i = 0; i < this.inscricao.length; i++) {
        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao[i].cod_incricao) {
          this.inscricao[i].cod_incricao = await this.verificaCodInscricao();
        }

        this.inscricao[i].eventoId = this.eventoSelecionado.id;
        this.inscricao[i].statusPagamento = "PENDENTE";
        this.inscricao[i].empresaId = this.empresa.id;
        this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim();
        this.inscricao[i].formOfPayment = formaPagamento;
        this.inscricao[i].parcelas = textoParcela;
        this.inscricao[i].divulgadorId = this.indicacao
          ? this.divulgador.id
          : undefined;
        this.inscricao[i].lote = this.eventoSelecionado.lote;

        if (!this.inscricao[i].valorPago) {
          if (formaPagamento == "CARTAO") {
            if (
              this.inscricao[i].tipoDocumento == "CNPJ" &&
              this.eventoSelecionado.desconto
            ) {
              this.inscricao[i].valorPago = (
                parseFloat(
                  this.eventoSelecionado.valorCartao.replace(",", ".")
                ) -
                parseFloat(this.eventoSelecionado.desconto.replace(",", "."))
              )
                .toFixed(2)
                .replace(".", ",");
            } else {
              this.inscricao[i].valorPago = this.eventoSelecionado.valorCartao;
            }
          } else if (formaPagamento == "PIX") {
            if (
              this.inscricao[i].tipoDocumento == "CNPJ" &&
              this.eventoSelecionado.desconto
            ) {
              this.inscricao[i].valorPago = (
                parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) -
                parseFloat(this.eventoSelecionado.desconto.replace(",", "."))
              )
                .toFixed(2)
                .replace(".", ",");
            } else {
              this.inscricao[i].valorPago = this.eventoSelecionado.valorPix;
            }
          }
        }
      }

      await axios
        .post(baseApiUrl + "inscricoes/criarInscricoes", this.inscricao)
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            for (let j = 0; j < this.inscricao.length; j++) {
              if (this.inscricao[j].cpf == response.data[i].cpf) {
                this.idInscricao.push(response.data[i].id);
                this.inscricao[j].id = response.data[i].id;
              }
            }
          }

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Erro ao realizar cadastro, tente novamente",
            "ERRO"
          );
        });
    },

    async verificaCodInscricao() {
      let codInscricao = new Date().getTime().toString();
      let codigoRetornado;

      await axios
        .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
          cod_incricao: codInscricao,
        })
        .then(async (response) => {
          if (response.data) {
            await this.verificaCodInscricao();
          }
        })
        .catch((error) => {
          if (error.response.data.error.message.includes("não localizada")) {
            codigoRetornado = codInscricao;
          }
        });

      return codigoRetornado;
    },

    async atualizaInscricao(callback = null) {
      this.inscricao.id = this.idInscricao;
      try {
        await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao);
        if (callback) {
          callback();
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao atualizar cadastro, tente novamente",
          "DESCULPE"
        );
      }
    },

    async enviaEmail() {
      try {
        await axios
          .post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {
            inscricaoId: this.idInscricao,
          })
          .then((res) => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao enviar e-mail, tente novamente",
          "DESCULPE"
        );
      }
    },

    async realizarConsulta() {
      if (this.cpf == "") {
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para realizar a consulta!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = true;
        var cpfSemMascara = this.cpf.replaceAll(".", "").replaceAll("-", "");
        await axios
          .get(
            `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`
          )
          .then((res) => {
            if (res.data != "") {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = "Inscrição localizada";
                this.cultoSelecionado = this.eventos[0].nome;
                this.isLoading = false;
                this.inscricao.nome = res.data[0].nome;
                this.inscricao.cpf = res.data[0].cpf;
                this.inscricao.email = res.data[0].email;
                this.inscricao.ddd = res.data[0].ddd;
                this.inscricao.telefone = res.data[0].telefone;
                this.inscricao.sexo = res.data[0].sexo;
                this.inscricao.cidade = res.data[0].cidade;
                this.inscricao.bairro = res.data[0].bairro;
                this.inscricao.participantes = res.data[0].participantes;
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.",
                  "ATENÇÃO"
                );
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome;
                  this.inscricao.nome = res.data[0].nome;
                  this.inscricao.cod_incricao = res.data[0].cod_incricao;
                  this.inscricao.email = res.data[0].email;
                  this.inscricao.participantes = res.data[0].participantes;
                  this.dialogoIngressoIndividual = true;
                  this.isLoading = false;
                }
              }
            } else {
              this.isLoading = false;
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Não foi localizada inscrição para os dados informados!",
                "ATENÇÃO"
              );
            }
          });
      }
    },

    async consultaInscricaoPendente(cpf, indice) {
      this.isLoading = true;

      await axios
        .get(
          baseApiUrl +
            'inscricoes?filter={"where":{"and":[{"eventoId":"' +
            this.eventoId +
            '"},{"cpf":"' +
            cpf +
            '"}]},"include":"evento"}'
        )
        .then((response) => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true;
              this.msgResultado = "Inscrição localizada";
              this.cultoSelecionado = this.eventos[0].nome;
              this.isLoading = false;
              this.inscricao[indice].cod_incricao =
                response.data[0].cod_incricao;
              this.inscricao[indice].nome = response.data[0].nome;
              this.inscricao[indice].cpf = response.data[0].cpf;
              this.inscricao[indice].email = response.data[0].email;
              this.inscricao[indice].sexo = response.data[0].sexo;
              this.inscricao[indice].cidade = response.data[0].cidade;
              this.inscricao[indice].bairro = response.data[0].bairro;
              this.inscricao[indice].telefone = response.data[0].telefone;
              this.inscricao[indice].eventoId = response.data[0].eventoId;
              this.inscricao[indice].codigoTransacao =
                response.data[0].codigoTransacao;
              this.inscricao[indice].estado = response.data[0].estado;
              this.inscricao[indice].cidade = response.data[0].cidade;
              this.inscricao[indice].id = response.data[0].id;
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.",
                "ATENÇÃO"
              );
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao;
              this.cultoSelecionado = response.data[0].evento.nome;
              this.inscricao.participantes = response.data[0].participantes;
              this.inscricao.nome = response.data[0].nome;
              this.codigoAcesso = response.data[0].codigoAcesso;
              this.inscricao.email = response.data[0].email;
              this.dialogoIngressoIndividual = true;
              this.isLoading = false;
            }
          } else {
            this.isLoading = false;
            this.consultaDadosCpf(cpf);
          }
        });
    },

    async consultaDadosCpf(cpf) {
      await axios
        .get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"' + cpf + '"}}')
        .then((response) => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim();
            this.inscricao.dataNascimento = response.data[0].dataNascimento;
            this.inscricao.telefone = response.data[0].telefone;
          }
        });
    },

    async verificaCapacidade() {
      this.isLoading = true;
      let vm = this;

      this.capacidadeEvento = this.eventoSelecionado.vagas;
      this.qtdInscritos =
        this.eventoSelecionado.quantidadeInscricoes +
        this.eventoSelecionado.reserva;

      if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos > 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 1;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, restam apenas " +
            (this.capacidadeEvento - this.qtdInscritos) +
            " vaga(s) disponível!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos == 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 0;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, todas as vagas foram esgotadas!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else {
        this.isLoading = false;
        if (this.qtdCompra > this.inscricao.length) {
          let novasInscricoes = [];

          for (let i = 0; i < this.qtdCompra - this.inscricao.length; i++) {
            novasInscricoes.push({
              cod_incricao: "",
              nome: "",
              cpf: "",
              email: "",
              sexo: "",
              telefone: "",
              igreja: "",
              caravana: "",
              eventoId: "",
              lote: "",
              tipo: "VIRTUAL",
              estado: "",
              cidade: "",
              tipoDocumento:
                this.eventoSelecionado.tipoDocumento == "AMBOS"
                  ? this.eventoSelecionado.documentoPadrao
                  : this.eventoSelecionado.tipoDocumento,
              valorPago: "",
            });
          }

          let novaLista = [...this.inscricao, ...novasInscricoes];
          this.inscricao = novaLista;
        } else {
          this.inscricao = this.removerElementos(
            this.inscricao,
            this.inscricao.length - this.qtdCompra
          );
        }
      }
    },

    removerElementos(lista, quantidade) {
      if (lista.length >= quantidade) {
        lista.splice(-quantidade, quantidade);

        return lista;
      }
    },

    async verificaVagas() {
      var vm = this;
      await axios
        .post(`${baseApiUrl}eventos/vagas`, { eventoId: this.eventoId })
        .then((response) => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              } else if (
                response.data.vagasRestantes < this.inscricao.participantes
              ) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, restam apenas " +
                    response.data.vagasRestantes +
                    " vaga(s) disponível(is)!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            }
            return true;
          }
        });
    },

    // método de pagamento
    /* async pagarCartao() {
      if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
          this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
          this.modelCartao.tipoTransacao = 'A_VISTA'
          this.inscricao.valorPago = this.valorEvento
          this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
          //dados do comprador
          this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
          this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          this.modelCartao.comprador.documentoTipo = '1'
          this.modelCartao.comprador.email = this.inscricao.email
          this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
          this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
          this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
          this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
          this.modelCartao.comprador.enderecoNumero = "1734"
          this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
          this.modelCartao.comprador.enderecoCep = "58031130"
          this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
          this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
          this.modelCartao.comprador.enderecoEstado = "PARAIBA"
          // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
          this.modelCartao.cartao.nome = this.pagamento.nomeTitular
          // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
          this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
          this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
          this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
          this.modelCartao.cartao.bandeira = this.pagamento.bandeira

          // dados para a inscrição
          this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
          this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
          this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
          this.inscricao.cardHolderName = this.pagamento.nomeTitular
          this.inscricao.cardFlag = this.pagamento.bandeira
          this.atualizaInscricao()
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
            if (res.data) {
              this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
              this.inscricao.nsu = res.data.transacao.nsu
              this.inscricao.paymentId = res.data.pagamentoId
              this.inscricao.formOfPayment = 'CARTAO'
              this.inscricao.statusPagamento = "PAGO"
              await this.atualizaInscricao()
              this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
          }
        } else {
          this.isLoading = false
          var vm4 = this;
          vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
        }
      } else {
        this.$validator.validateAll()
      }
    }, */

    /* async pagarBoleto() {
      await this.realizarInscricao()
      if (this.idInscricao) {
        this.isLoading = true
        // criando data de vencimeto do boleto
        var datapagvenc = new Date();
        datapagvenc.setDate(new Date().getDate())
        // criando nosso número
        var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
        // preencher o campos do modelBoleto
        modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
        modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
        modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
        modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
        modelBoleto.pagadorCidade = "JOAO PESSOA"
        modelBoleto.pagadorUf = "PB"
        modelBoleto.pagadorCep = "58031130";
        modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
        // salvando o responsibility e o valor do boleto caso seja anual
        modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
        modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
        modelBoleto.nsu = this.inscricao.cod_incricao
        modelBoleto.nossoNumero = nossoNum.substr(0,12)
        modelBoleto.seuNumero = nossoNum.substr(0,12)
        // gerando o Boleto e pegando o ID
        try {
          let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
          if (res.data != '') {
            this.inscricao.boletoId = res.data.id
            this.inscricao.formOfPayment = 'BOLETO'
            this.inscricao.situacaoBoleto = 'GERADO'
            this.inscricao.nsu = modelBoleto.nsu
            this.inscricao.nossoNumero = modelBoleto.nossoNumero
            this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
            this.inscricao.statusPagamento = 'PENDENTE'
            await this.atualizaInscricao()
            await this.imprimirBoleto()
            await this.finalizaInscricao()
          }
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
          this.close()                 
        }                
      } else {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
      }
    }, */

    async pagamentoCartao() {
      let vm = this;

      if (
        this.pagamento.nomeTitular != "" &&
        this.pagamento.cartaoNumero != "" &&
        this.pagamento.cpfTitular != "" &&
        this.pagamento.cvv != "" &&
        this.pagamento.mesVencimento != "" &&
        this.pagamento.anoVencimento != "" &&
        this.pagamento.bandeira != "" &&
        this.pagamento.cep != "" &&
        this.pagamento.numero != "" &&
        this.pagamento.email != "" &&
        this.pagamento.valor != 0
      ) {
        this.isLoading = true;

        await this.realizarInscricao(null, "CARTAO", this.textoParcela);
        await this.criarClienteAsaas();
        if (this.idInscricao.length > 0) {
          try {
            let codInscricaoGeral;

            for (let i = 0; i < this.inscricao.length; i++) {
              if (i == 0) {
                codInscricaoGeral = this.inscricao[i].cod_incricao;
              } else {
                codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
              }
            }
            this.cobrancaAsaasCartao.customer = this.idClienteAsaas;
            this.cobrancaAsaasCartao.billingType = "CREDIT_CARD";
            this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor);
            this.cobrancaAsaasCartao.installmentValue = parseFloat(
              parseFloat(this.pagamento.valor) /
                this.cobrancaAsaasCartao.installmentCount
            );
            this.cobrancaAsaasCartao.dueDate = moment().format("YYYY-MM-DD");
            this.cobrancaAsaasCartao.description =
              "Ref. ao evento " +
              this.eventoSelecionado.nome +
              " para as insc. de nº " +
              codInscricaoGeral;
            this.cobrancaAsaasCartao.inscricaoId = this.idInscricao;
            this.cobrancaAsaasCartao.empresaId = this.empresa.id;
            axios.get("https://api.ipify.org/?format=json").then((res) => {
              if (res.data) {
                try {
                  this.cobrancaAsaasCartao.remoteIp = res.data.ip;
                } catch (error) {
                  this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
                }
              } else {
                this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
              }
            });
            // inserindo dados do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCard.holderName =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCard.number =
              this.pagamento.cartaoNumero;
            this.cobrancaAsaasCartao.creditCard.expiryMonth =
              this.pagamento.mesVencimento;
            this.cobrancaAsaasCartao.creditCard.expiryYear =
              this.pagamento.anoVencimento;
            this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv;
            // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCardHolderInfo.name =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.email =
              this.pagamento.email.trim().toLowerCase();
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj =
              this.pagamento.cpfTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode =
              this.pagamento.cep;
            this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber =
              this.pagamento.numero;
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone =
              this.inscricao[0].telefone.replace(/[^\d]+/g, "");
            await axios
              .post(
                baseApiUrl + "Pagamentos/AsaasCobranca",
                this.cobrancaAsaasCartao
              )
              .then((response) => {
                if (response.data.cobranca.status == "CONFIRMED") {
                  this.finalizaInscricao();
                  if (this.cupomAplicado) this.atualizaCupomsUtilizados();
                }
              });
          } catch (error) {
            this.idInscricao = [];
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.",
              "DESCULPE"
            );
          }
        } else {
          this.idInscricao = [];
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao realizar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        this.$validator.validateAll();
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para continuar!",
          "ATENÇÃO"
        );
      }
    },

    async criarClienteAsaas() {
      this.clienteAsaas.name = this.pagePagamento
        ? this.pagamento.nomeTitular
        : this.inscricao[0].nome;
      this.clienteAsaas.cpfCnpj = this.pagePagamento
        ? this.pagamento.cpfTitular
        : this.inscricao[0].cpf;
      this.clienteAsaas.email = this.pagamento.email;
      this.clienteAsaas.mobilePhone = this.inscricao[0].telefone.replace(
        /[^\d]+/g,
        ""
      );
      this.clienteAsaas.postalCode = this.pagamento.cep;
      this.clienteAsaas.addressNumber = this.pagamento.numero;
      this.clienteAsaas.empresaId = this.empresa.id;

      try {
        await axios
          .post(baseApiUrl + "Pagamentos/criarCliente", this.clienteAsaas)
          .then((response) => {
            if (response.data) {
              this.idClienteAsaas = response.data.id;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagamentoBoleto() {
      this.isLoading = true;

      await this.realizarInscricao(null, "BOLETO", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        try {
          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra.replace(",", ".")) +
            parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "BOLETO";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.cultoSelecionado +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas)
            .then((res) => {
              if (res.data) {
                this.linkBoleto = res.data.cobranca.bankSlipUrl;
                this.finalizaInscricao();
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Problema encontrado ao gerar o boleto. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    abreBoleto() {
      window.open(this.linkBoleto);
    },

    async pagarPixAsaas() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao.length > 0) {
        try {
          let codInscricaoGeral;

          for (let i = 0; i < this.inscricao.length; i++) {
            if (i == 0) {
              codInscricaoGeral = this.inscricao[i].cod_incricao;
            } else {
              codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
            }
          }

          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra) +
            parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "PIX";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(baseApiUrl + "Pagamentos/AsaasCobranca", this.cobrancaAsaas)
            .then((response) => {
              if (response.data) {
                this.inscricao.codigoTransacao =
                  response.data.cobranca.invoiceUrl;
                this.qrCode64 =
                  "data:image/jpeg;base64," + response.data.qrCode.encodedImage;
                this.chaveCopiaeCola = response.data.qrCode.payload;
                this.msgResultado = "Pré-inscrição realizada com sucesso";
                this.pagamentoPix = true;
                this.isLoading = false;
                this.inscricao.id = this.idInscricao;
                this.consultaPagamentoPix(response.data.id);
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.idInscricao = [];
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao gerar pagamento. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.idInscricao = [];
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    consultaPagamentoPix() {
      try {
        this.verificaPagamento = setInterval(
          function () {
            axios
              .post(baseApiUrl + "Pagamentos/AsaasCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "RECEIVED") {
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixTaPago() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }
        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          valor: "",
          descricao:
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para a insc. de nº " +
            codInscricaoGeral,
        };

        dadosCobranca.valor = (
          parseFloat(this.valorTotalCompra) +
          parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
        ).toFixed(2);

        await axios
          .post(baseApiUrl + "Pagamentos/taPagoCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 =
                "data:" +
                response.data.instantPayment.generateImage.mimeType +
                ";base64," +
                response.data.instantPayment.generateImage.imageContent;
              this.chaveCopiaeCola = response.data.instantPayment.textContent;
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixTaPago();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Falha ao gerar pagamento. Tente novamente mais tarde.",
              "DESCULPE"
            );
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async consultaPagamentoPixTaPago() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios
              .post(baseApiUrl + "Pagamentos/taPagoCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixSicoob() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: this.inscricao[0].cpf.replace(/[^\d]/g, ''),
            nome: this.inscricao[0].nome,
          },
          valor: {
            original: ""
          },
          chave: "ecommerce@intelite.com.br",
          solicitacaoPagador: "INTELITE TECNOLOGIA",
        };

        dadosCobranca.valor.original = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))).toFixed(2);

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
        .then((response) => {
          if (response.data) {
            this.qrCode64 = response.data.brcode
            this.chaveCopiaeCola = response.data.brcode
            this.msgResultado = "Pré-inscrição realizada com sucesso";
            this.pagamentoPix = true;
            this.isLoading = false;
            this.consultaPagamentoPixSicoob();
            if (this.cupomAplicado) this.atualizaCupomsUtilizados();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
        });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE"
        );
      }
    },

    async consultaPagamentoPixSicoob() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"inscricaoId": this.idInscricao[0]})
            .then((res3) => {
              if (res3.data.status == "APPROVED") {
                this.isLoading = true;
                this.finalizaInscricao();
                clearInterval(this.verificaPagamento);
              }
            });
          }.bind(this), 5000);
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async imprimirBoleto() {
      //Baixando Boleto PDF
      try {
        let res = await axios.get(
          `https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + this.token, //the token is a variable which holds the token
              "Content-type": "application/pdf",
            },
          }
        );
        if (res.data) {
          //Create a Blob from the PDF Stream
          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", "boleto.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          //Open the URL on new Window
          window.open(fileURL);
          //exibe mensagem de conclusao
          this.isLoading = false;
          this.dialogLoading = true;
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!",
          "ERRO"
        );
      }
    },

    finalizaInscricao() {
      this.isLoading = false;
      if (this.inscricao.formOfPayment == "CARTAO") {
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      } else if (this.inscricao.formOfPayment == "BOLETO") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoBoleto = true;
      } else if (this.inscricao.formOfPayment == "EM MAOS") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoEmMaos = true;
      } else {
        this.pagamentoPix = false;
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      }
    },

    //Função para criptografia
    encrypt(text) {
      let crypto = require("crypto");
      let password = "pxuelh2so839ljis";
      let iv = "pxuelh2so839ljis";
      let cipher = crypto.createCipheriv("aes-128-cbc", password, iv);
      let encryptedData =
        cipher.update(text, "utf8", "Base64") + cipher.final("Base64");
      return encryptedData;
    },

    closeDialog() {
      this.pagamentoPix = false;
      if (!this.consultaCPF) {
        this.reloadPage();
      }
      this.$validator.reset();
      if (this.consultaCPF) {
        this.consultaCPF = false;
        this.inscricao = Object.assign({}, this.inscricaoDefault);
      }
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.nome;
      const dataB = b.nome;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    calculateAge(dobString) {
      var dob = new Date(dobString);
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var birthdayThisYear = new Date(
        currentYear,
        dob.getMonth(),
        dob.getDate()
      );
      var age = currentYear - dob.getFullYear();
      if (birthdayThisYear > currentDate) {
        age--;
      }
      return age;
    },

    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async pegaParametrosUrl() {
      var params = window.location.search.substring(1).split("&");
      if (params[0] != "") {
        this.isLoading = true;
        let paramArray = {}; // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {
          // Passar por todos os parametros
          var param = params[i].split("="); // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1]; // Adicionar ao objeto criado antes
        }

        if (paramArray["cod"]) {
          await axios
            .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
              cod_incricao: paramArray["cod"],
            })
            .then(async (response) => {
              if (response.data) {
                if (response.data.statusPagamento == "PAGO") {
                  this.inscricaoLocalizada = Object.assign({}, response.data);
                  this.dialogoIngressoIndividual = true;
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Pagamento da inscrição não foi efetuado.",
                    "ATENÇÃO"
                  );
                }
              }
            });
        }
        if (paramArray["d"]) {
          this.consultaDivulgador(paramArray["d"]);
        }
        if (paramArray["e"]) {
          await axios
            .post(baseApiUrl + "eventos/porId", { eventoId: paramArray["e"] })
            .then((response) => {
              if (response.data) {
                if (
                  moment(
                    this.formatDateHora(response.data.fim),
                    "DD/MM/YYYY HH:mm:ss",
                    true
                  ).format() >= moment().format()
                ) {
                  this.bloqueiaVoltar = true;
                  this.realizarInscricaoGrupo(response.data);
                }
              }
            });
        }
      }
      this.isLoading = false;
    },

    async salvaHoraVisualizacao(id) {
      await axios.patch(baseApiUrl + "inscricoes/" + id, {
        visualizado: true,
        ultimaVisualizacao: moment().toISOString(),
      });
    },

    async consultarInscricao(cpf, cod) {
      var vm = this;
      if (cpf) {
        this.isLoading = true;
        let envio = {
          eventoId: this.eventoId,
          cpf: cpf,
          enviaToken: true,
          canalNotificacao: "ZAP",
          cod_incricao: cod,
        };
        try {
          await axios
            .post(`${baseApiUrl}inscricoes/consultarInscricao`, envio)
            .then((response) => {
              if (response.data.length > 0) {
                this.idInscricao = response.data;
                this.dialogoToken = true;
                this.consultaCPF = true;
                this.isLoading = false;
              }
            });
        } catch (error) {
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao consultar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o CPF para consultar",
          "ATENÇÃO"
        );
      }
    },

    async confirmaToken() {
      var vm = this;
      if (this.token) {
        this.isLoading = true;
        let confirmacao = {
          token: this.token,
          inscricaoId: this.idInscricao,
        };
        await axios
          .post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then((response) => {
            if (response.data) {
              if (response.data.statusPagamento == "PAGO") {
                this.consultaCPF = true;
                this.cultoSelecionado = this.eventos[0].nome;
                this.inscricao.nome = response.data.nome;
                this.inscricao.cod_incricao = response.data.cod_incricao;
                this.inscricao.email = response.data.email;
                this.inscricao.participantes = response.data.participantes;
                this.dialogoToken = false;
                this.token = "";
                this.dialogoIngressoIndividual = true;
                this.isLoading = false;
                this.idInscricao = "";
              } else if (response.data.statusPagamento == "PENDENTE") {
                this.inscricaoLocalizada = true;
                this.consultaInscricao(this.idInscricao);
                if (response.data.participantes > 1) {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoGrupo();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                } else {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoAgora();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                }
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "CANCELADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação cancelada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "ESTORNADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação estornada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              }
            } else {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Token inválido, tente novamente",
                "ATENÇÃO"
              );
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Problema ao confirmar token, tente novamente",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o token enviado para continuar",
          "ATENÇÃO"
        );
      }
    },

    async consultaInscricao(id) {
      await axios.get(baseApiUrl + "inscricoes/" + id).then((response) => {
        if (response.data) {
          this.inscricao.nome = response.data.nome;
          this.inscricao.cpf = response.data.cpf;
          this.inscricao.dataNascimento = response.data.dataNascimento;
          this.inscricao.telefone = response.data.telefone;
          this.inscricao.possuiNecessidade = response.data.possuiNecessidade;
          this.inscricao.necessidadeEspecial =
            response.data.necessidadeEspecial;
        }
      });
    },

    async consultaDivulgador(id) {
      await axios.get(baseApiUrl + "Divulgadores/" + id).then((response) => {
        if (response.data) {
          if (response.data.ativo) {
            this.indicacao = true;
            this.divulgador = response.data;
            axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 })
          }
        }
      });
    },

    retornaData(tipo) {
      return moment().format(tipo);
    },

    retornaPaginaPrincipal() {
      this.eventoSelecionado = [];
      this.inscricao = this.inscricaoDefault;

      if (this.PageIncricao) {
        this.PageIncricao = false;
      } else {
        this.paginaInscricaoGrupo = false;
      }

      this.pagePrincipal = true;
    },

    async buscaUfs() {
      await axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome")
      .then(response => {
        if (response.data) {
          this.estados = response.data;
        }
      });
    },

    async buscaMunicipios() {
      await axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado")
      .then(response => {
        if (response.data) {
          this.municipios = response.data;
        }
      });
    },

    getItemText(item) {
      return item.nome;
    },

    calculaValorTotal(setor, indice) {
      let vm = this;

      // localiza o setor escolhido pelo preço e o salva na inscrição
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        if (this.eventoSelecionado.setores[i].nome == setor) {
          if (
            this.verificaVagaDisponivel(
              this.eventoSelecionado.setores[i].nome
            ) > 0
          ) {
            this.inscricao[indice].valorPago =
              this.eventoSelecionado.setores[i].valor;
            this.inscricao[indice].corSetor =
              this.eventoSelecionado.setores[i].cor;
          } else {
            this.inscricao[indice].valorPago = "";
            this.inscricao[indice].setor = "";
            this.inscricao[indice].corSetor = "";
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Quantidade máxima atingida para o setor",
              "ATENÇÃO"
            );
          }
          break;
        }
      }

      if (
        this.inscricao[indice].tipoDocumento == "CNPJ" &&
        this.eventoSelecionado.desconto
      ) {
        this.inscricao[indice].valorPago = parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".") -
            this.eventoSelecionado.desconto.replace(",", ".")
        )
          .toFixed(2)
          .replace(".", ",");
      }

      this.valorTotalCompra = 0;

      this.inscricao.forEach((inscricao) => {
        if (inscricao.valorPago) {
          this.valorTotalCompra += parseFloat(
            inscricao.valorPago.replace(",", ".")
          );
        }
      });

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async pegaVagasDisponiveis() {
      await axios
        .post(baseApiUrl + "Empresas/vagasDisponiveis", {
          empresaId: this.empresa.id,
        })
        .then((response) => {
          if (response.data) {
            this.vagasDisponiveis = response.data;
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] =
                  this.vagasDisponiveis[this.inscricao[i].setor] - 1;
              }
            }
          }
        });
    },

    verificaVagaDisponivel(setor) {
      return this.vagasDisponiveis[setor] - 1;
    },

    limpaSetor(indice) {
      if (this.inscricao[indice].valorPago) {
        this.valorTotalCompra -= parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".")
        );
      }

      this.inscricao[indice].valorPago = "";
      this.inscricao[indice].setor = "";
      this.inscricao[indice].corSetor = "";
    },

    customFilter(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedItem = this.normalizeText(item.nome);

      return normalizedItem.indexOf(normalizedQuery) > -1;
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    customFilterCidade(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedItem = this.normalizeText(item["municipio-nome"]);

      return normalizedItem.indexOf(normalizedQuery) > -1;
    },
  },
};
</script>

<style scoped>
/* LOGIN */

.font-bold {
  font-family: "Times New Roman", serif;
  font-weight: bold;
}

.font-regular {
  font-family: "Times New Roman", serif;
  font-weight: normal;
  font-size: 1.1rem;
}

.font-bold-italic {
  font-family: "Times New Roman", serif;
  font-weight: bold;
  font-style: italic;
}

.black-color {
  color: #414141;
}

.white-color {
  color: #ffffff;
  background-color: #b71c1c;
  font-size: 1.1rem;
}

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #424242, #616161);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 0px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.no-break {
  word-wrap: normal;
  /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
  word-break: keep-all;
  /* Isso também ajuda a prevenir a quebra no meio de palavras */
  white-space: pre-line;
  /* Isto vai respeitar os espaços em branco e quebras de linha */
}

a {
  text-decoration: none;
}
</style>
